import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { AddFaqRequest } from '@/types/request/AddFaqRequest';
import { queryClient } from '@/main.tsx';

const useFaqAdd = () => {
  const client = supabaseClient;

  const mutationFn = async (request: AddFaqRequest) => {
    return addFaq(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['faq'] });
    },
  });
};

export default useFaqAdd;

async function addFaq(client: SupabaseClient, request: AddFaqRequest): Promise<void> {
  const { data: question, error: errorQuestion } = await client
    .from('questions')
    .insert({
      restaurant_id: request.restaurant_id,
      question: request.question,
    })
    .select('id')
    .maybeSingle();

  if (errorQuestion) throw new Error(errorQuestion.message);
  if (!question) throw new Error('Failed to add FAQ. Try with another question.');

  const { data: answer, error: errorAnswer } = await client
    .from('answers')
    .insert({
      question_id: question.id,
      answer: request.answer,
    })
    .select('id')
    .maybeSingle();

  if (errorAnswer) throw new Error(errorAnswer.message);
  if (!answer) throw new Error('Failed to add FAQ. Try with another answer.');

  return;
}
